import firebase, { database } from '@/plugins/firebase';
import { callFn } from '@/utils/functionsClient';
import { receiptsCollection } from '@/store/modules/ReceiptModule';
export async function fetchReceipt(receiptId) {
    const doc = await database.collection(receiptsCollection()).doc(receiptId).get();
    return doc.exists ? { id: doc.id, data: doc.data() } : null;
}
/** Resolves true once the agent authorized the payment, false when it failed or the user gave up. */
function awaitCardPayment(requestId, amount) {
    document.dispatchEvent(new CustomEvent('openCardPaymentDialog', {
        detail: { requestId, amount },
    }));
    return new Promise(resolve => {
        const closeDialog = (e) => {
            document.removeEventListener('closeCardPaymentDialog', closeDialog);
            resolve(e.detail.success);
        };
        document.addEventListener('closeCardPaymentDialog', closeDialog);
    });
}
/**
 * Collects one payment. Non-card methods are a single callable; a card payment is queued for the
 * terminal and finalized once the agent reports the authorization. Without a configured terminal
 * the card is charged on the operator's own device and the server books the payment right away.
 * Returns null when the card payment was declined or cancelled.
 */
export async function collectPayment(callable, payload, method) {
    const result = await callFn(callable, { ...payload, method });
    if (!('requestId' in result)) {
        return result;
    }
    if (!await awaitCardPayment(result.requestId, result.amount)) {
        return null;
    }
    return callFn('finalizeCardPayment', { requestId: result.requestId });
}
/**
 * The server decides whether the receipt goes to the terminal printer; when it does not,
 * it returns the stored PDF to open instead.
 */
export async function printReceipt(receiptId) {
    const result = await callFn('printReceipt', { receiptId });
    if (result.requestId) {
        return;
    }
    if (!result.pdfPath) {
        throw new Error('Tiskárna není k dispozici a doklad ještě nemá PDF.');
    }
    window.open(await firebase.storage().ref(result.pdfPath).getDownloadURL(), '_blank');
}
